import { useRouter } from 'next/router';
import { Spin, message, Tour, Carousel } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import gaTracker from "@/ga";
import { Icon } from "@iconify/react";
import useLogin from "@/hooks/useLogin";
import Empty from '@/components-mobile/Empty';
import Modal from '@/components-mobile/Modal';
import Footer from "@/components-mobile/Footer";
import LoginModal from "@/components/LoginModal";
import TourModal from "@/components-mobile/Tour";
import EligibleModal from '@/components/EligibleModal';
import CommonLoading from "@/components/CommonLoading";
import eventSub, { EventName } from "@/common/EventSub";
import HotSaleBox from '@/components-mobile/HotSaleBox';
import ProductCard from '@/components-mobile/productCard';
import SubNotAuthMobile from '@/components/SubNotAuthMobile';
import FeedbackPopup from "@/components-mobile/FeedbackPopup";
import SelectTagPopup from "@/components-mobile/SelectTagPopup";
import { generateRandomStringWithTimestamp } from "@/utils/utils";
import { APIGetLinkByPid, APIH5ClickStatistics, APIGetGuideFinish, APIGetUserInfo, APIGetCheckV2Permissions, APIGetHomeBanner, APIGetHomeBannerClick } from "@/api";
import styles from './index.module.scss';
import Condition from './components/condition';
import SearchBar from '../../components-mobile/Home/search-bar';
import { fetchProductList, fetchAddCollect, fetchDeleteCollect } from '../../redux/actions/home-mobile';
import useLanguage from "@/hooks/useLanguage";


const HomeMobile = () => {
  const { t, currentLang, isUS } = useLanguage();
  const router = useRouter();
  const dispatch = useDispatch();
  const { needLogin, loginModalShow } = useLogin();
  const [feedback, setFeedback] = useState(false);
  const [loading, setLoading] = useState(false);   // 页面触底loading
  const [page, setPage] = useState(1); // 加载页数，第一页已经加载
  const [more, setMore] = useState(false);  // 当加载5个页面后，手动加载一次
  const [hasLoaded, setHasLoaded] = useState(false);  // 标记数据是否加载完成
  const [showConnectTips, setShowConnectTips] = useState(false);  // 登录提示
  const [tourOpen, setTourOpen] = useState(false);  // 控制 Tour 弹窗显示的状态
  const [currentStep, setCurrentStep] = useState(0);
  const [obtain, setObtain] = useState(false);  // cap  tap
  const [selectedTag, setSelectedTag] = useState();  // true 需要选择标签
  const [eligibleModal, setEligibleModal] = useState(false);
  const [quickTips, setQuickTips] = useState(false);
  const [userPermissions, setUserPermissions] = useState(-1); // -1:等待接口返回， 1:已经授权  0:
  const [notAuthMobile, setNotAuthMobile] = useState(false);
  const [bannerList, setBannerList] = useState([]); // 轮播图数据
  const loadingRef = useRef(false); // 使用 ref 来标记是否正在加载
  const { productList, apiLoading, total, productListParams } = useSelector((state) => {
    return state.fetchProductList;
  });
  const userInfo = useSelector(state => state.home.userInfo.userInfo);
  // 定义步骤，每个步骤包括 title, description, target
  const steps = [
    {
      description: <TourModal
        des={<div>
          <span className={"text-[#FF6E1F] font-bold"}> {t('product.action.view_details')} </span> {t('home_mobile.tour.step1.text')}
        </div>}
        index={1} next={() => setCurrentStep(currentStep + 1)} skip={() => setTourOpen(false)} />,
      target: () => document.querySelector("#step1"),
      nextButtonProps: null,
      prevButtonProps: null,
    },
    {
      description: <TourModal
        lineClassName={"rotate-[-90deg]"}
        wrapLintClassName={"!left-[-120px] !top-[-45px]"}
        des={<div>
          <ul className={styles.tourCustomList}>
            <li>{t('home_mobile.tour.step2.view_details')} <span className={"text-[#FF6E1F] font-bold"}> {t('product.action.view_details')} </span>.</li>
            <li>{t('home_mobile.tour.step2.add_showcase')} "<span className={"text-[#FF6E1F] font-bold"}>{t('product.add_to_showcase')}</span>" {t('home_mobile.tour.step2.add_showcase_to')}.</li>
            <li>{t('home_mobile.tour.step2.request_sample')} "<span className={"text-[#FF6E1F] font-bold"}>{t('product.action.collect')}</span>" {t('home_mobile.tour.step2.request_sample_to')}.</li>
            <li>{t('home_mobile.tour.step2.collect')} <span className={"text-[#FF6E1F] font-bold"}> {t('header.collection')} </span>, {t('home_mobile.tour.step2.and_then')} "{t('product.add_to_showcase')}"!</li>
          </ul>
        </div>}
        className={"mr-[200px]"} index={2} next={() => setCurrentStep(currentStep + 1)} pre={() => setCurrentStep(currentStep - 1)} skip={() => setTourOpen(false)} />,
      target: () => document.querySelector("#step2"),
      placement: "right",
      nextButtonProps: null,
      prevButtonProps: null,
    },
    {
      description: <TourModal des={
        <div>
          {t('home_mobile.tour.step3.click_here')} <span className={"text-[#FF6E1F] font-bold"}> {t('header.analysis')} </span>、<span className={"text-[#FF6E1F] font-bold"}> {t('header.showcase')} </span>、<span className={"text-[#FF6E1F] font-bold"}> {t('header.collection')} </span>, {t('home_mobile.tour.step3.you_can_also')} <span className={"text-[#FF6E1F] font-bold"}> {t('product.commission')}</span> {t('home_mobile.tour.step3.products_here')}.
        </div>
      } index={3} onEnd={() => { setTourOpen(false); APIGetGuideFinish(); }} pre={() => setCurrentStep(currentStep - 1)} />,
      target: () => document.querySelector("#step3"),
      nextButtonProps: null,
      prevButtonProps: null,
    }
  ];

  useEffect(() => {
    if (loginModalShow) {
      setShowConnectTips(loginModalShow);
    }
  }, [loginModalShow]);

  // 页面加载时调用接口
  useEffect(() => {
    const randomNum = localStorage.getItem("randomNum") ?? generateRandomStringWithTimestamp();
    if (!localStorage.getItem("randomNum")) {
      localStorage.setItem("randomNum", randomNum);
    }
    // 初始化获取用户信息和权限
    const token = localStorage.getItem("token");
    if (token) {
      checkPermission().then();
    }
    let params;
    if (productListParams?.sort === 5) {
      params = { page: 1, uuid: randomNum };
    } else {
      params = { page: 1 };
    }
    dispatch(fetchProductList({ ...productListParams, ...params }));

    // 获取轮播图数据
    APIGetHomeBanner().then(res => {
      if (res?.data?.result) {
        setBannerList(res.data.result);
      }
    }).catch(error => {
      console.error('获取轮播图数据失败:', error);
    });

    const element = document.getElementById("home_search_bar_h5");
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          eventSub.publish(EventName.HomeSearchShow);
        } else {
          eventSub.publish(EventName.HomeSearchUnShow);
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);
  // 获取用户信息  标签信息 是否签约
  useEffect(() => {
    if (userInfo && typeof userInfo === 'object') {
      setTourOpen(userInfo?.needGuide ? true : false);
      setObtain(userInfo?.obtain ? true : false);
      setSelectedTag(userInfo?.needSelectedTag === null ? true : false);
    }

  }, [userInfo]);

  useEffect(() => {
    // 如果加载的数据量已经达到总数，停止加载更多
    if (productList.length >= total) {
      loadingRef.current = true;
      setLoading(false);
    } else {
      setLoading(true);
      loadingRef.current = false;
    }
    if (total === 0 && productListParams.page === 1) {
      setHasLoaded(true);
    } else {
      setHasLoaded(false);
    }
  }, [productList]);
  // 监听滚动事件
  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
      // 判断是否滚动到底部
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreData();
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [productListParams, loading]);

  useEffect(() => {
    if (tourOpen) {
      document.body.style.overflow = "hidden"; // 禁止滚动
    } else {
      document.body.style.overflow = ""; // 允许滚动
    }
    return () => {
      document.body.style.overflow = ""; // 组件卸载时恢复
    };
  }, [tourOpen]);

  // 手动触发加载更多
  useEffect(() => {
    if (more) {
      loadingRef.current = false;
      loadMoreData();
    }
  }, [more]);
  const switchObtain = () => {
    const token = localStorage.getItem("token");
    if (token) {
      APIGetUserInfo().then(resp => {
        setObtain(resp.data.user?.obtain);
        localStorage.setItem("user", JSON.stringify(resp.data.user));
      });
    }
  };
  const checkPermission = async () => {
    await new Promise((resolve) => {
      APIGetCheckV2Permissions().then(resp => {
        if (resp.data) {
          setUserPermissions(resp.data?.permissions ? 1 : 0);
          resolve();
        }
      }).finally(() => {
        resolve();
      });
    });
  };

  const loadMoreData = () => {
    if (loadingRef.current) return;
    loadingRef.current = true; // 标记为正在加载
    setLoading(true);
    setPage(productListParams.page + 1);
    // 翻五页后手动触发一次
    if (productListParams.page % 5 === 0 && !more) return;
    setMore(false);
    const randomNum = localStorage.getItem("randomNum") ?? generateRandomStringWithTimestamp();
    if (!localStorage.getItem("randomNum")) {
      localStorage.setItem("randomNum", randomNum);
    }
    let params;
    if (productListParams?.sort === 5) {
      params = { page: productListParams.page + 1, uuid: randomNum };
    } else {
      params = { page: productListParams.page + 1 };
    }
    dispatch(fetchProductList({ ...productListParams, ...params }));
  };

  const goSearchPage = () => {
    router.push({
      pathname: '/search-page-mobile/'
    });
  };

  const collectChange = (e, data, collected) => {
    e.stopPropagation();
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    if (needLogin) {
      setShowConnectTips(true);
      return;
    }
    if (collected) {
      gaTracker.trackEvent("home_remove_collect");
      dispatch(fetchDeleteCollect({ uid: user.id, itemId: data.productId }));
    } else {
      gaTracker.trackEvent("home_collect");
      dispatch(fetchAddCollect({ uid: user.id, itemId: data.productId }));
    }
  };
  const addChange = (e, data) => {
    gaTracker.trackEvent("home_add_showcase");
    APIH5ClickStatistics({ productIds: data?.productId.toString() }).then().catch();
    e.stopPropagation();
    if (needLogin) {
      setShowConnectTips(true);
      return;
    }
    try {
      if (data.needApplyLink) {
        APIGetLinkByPid(data.productId).then(resp => {
          if (resp?.data.url) {
            const url = resp.data.url;
            console.log('~url', url);
            window.location.href = url;
          } else {
            message.info(t('product.error.taken_down'));
          }
        }).catch(e => {
          message.error(t('common.error'));
        }).finally(() => {
        });
      } else {
        const url = data.url;
        window.location.href = url;
      }
    } catch (e) {
      message.error(t('common.error'));
    }
  };
  const goDetailPage = (data) => {
    gaTracker.trackEvent("home_product_card");
    router.push(`/details-mobile/${data.productId}?country=${currentLang.code}`);
  };
  const openEmail = () => {
    gaTracker.trackEvent("home_comm_increase");
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    if (needLogin) {
      setShowConnectTips(true);
      return;
    }
    if (!userPermissions) {
      setNotAuthMobile(true);
      return;
    }
    router.push(`/showcase-mobile?type=commission&obtain=${user?.obtain}`);

    // const email = 'contact@anystarr.com';
    // const subject = 'To anystarr';

    // 使用mailto协议打开默认的电子邮件客户端
    // 打开邮件客户端
    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  };
  const openFeedback = () => {
    gaTracker.trackEvent("home_feedback_click");
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    if (needLogin) {
      setShowConnectTips(true);
      return;
    }
    setFeedback(true);
  };
  return (
    <div className={styles.homeMobile}>
      {/* 轮播图 */}
      {bannerList && bannerList.length > 0 && (
        <div className={styles.bannerContainer}>
          <Carousel
            autoplay
            autoplaySpeed={3000}
            dots={true}
            arrows={false}
            className={styles.bannerCarousel}
          >
            {bannerList.map((banner, index) => (
              <div key={index} className={styles.bannerItem}>
                <img
                  src={banner.imageUrl}
                  alt={banner.title || 'Banner'}
                  className={styles.bannerImage}
                  onClick={() => {
                    APIGetHomeBannerClick(banner?.id).then();
                    if (banner.linkUrl) {
                      window.location.href = banner.linkUrl;
                    }
                  }}
                />
              </div>
            ))}
          </Carousel>
        </div>
      )}

      <HotSaleBox obtain={obtain} />
      <div id='step1' >
        <div id='home_search_bar_h5'><SearchBar onPress={goSearchPage} productListParams={productListParams} /></div>
        <Condition />
      </div>

      <Spin spinning={apiLoading && page === 1} indicator={<CommonLoading />}>
        <div className={styles.content} >
          <div className={styles.productBox}>
            {productList.length !== 0 && productList.map((item, index) => (
              <ProductCard
                obtain={obtain}
                sourceData={item}
                key={index}
                typePage='home'
                collectChange={collectChange}
                goDetailPage={goDetailPage}
                addChange={addChange}
                switchObtain={switchObtain}
              />
            ))}
          </div>
          {page !== 1 && loading && ((page - 1) % 5 !== 0
            ? <div className={"flex items-center justify-center"}><CommonLoading className={"w-[30px] h-[30px]"} /></div>
            : <>
              <div className={styles.seeMore} onClick={() => setMore(true)}>{t('home_mobile.see_more')}<Icon icon='tabler:arrow-narrow-right-dashed' className={styles.moreIcon} /></div>
            </>
          )}
          {hasLoaded && <>
            <Empty typePage={'home'} />
          </>}

        </div>
      </Spin>
      <Footer />
      <div className={styles.quickBox}>
        <Icon icon='fluent:phone-add-20-filled' className={styles.docuIcon} onClick={() => setQuickTips(true)} />
      </div>
      <div className={styles.docuBox}>
        <Icon icon='material-symbols:chat-paste-go-rounded' className={styles.docuIcon} onClick={openFeedback} />
      </div>
      {
        isUS && <div className={styles.mailBox}>
          <Icon icon='streamline-sharp:dollar-increase-solid' className={styles.mailIcon} onClick={openEmail} />
        </div>
      }
      <LoginModal open={showConnectTips} mobile={true} onCancel={() => setShowConnectTips(false)}></LoginModal>
      {/* 使用 Tour 组件 */}
      <Tour closeIcon={false} disabledInteraction={true} gap={{ radius: currentStep === 2 ? 20 : 4 }} steps={steps} open={tourOpen} current={currentStep} arrow={false} onClose={() => setTourOpen(false)} />
      {tourOpen && currentStep !== 2 && <div className={styles.skip} onClick={() => { setTourOpen(false); APIGetGuideFinish(); }} >
        <div className={"w-[86px] h-[28px] cursor-pointer flex items-center justify-center text-[#fff] border border-[#fff] rounded-full"}>{t('home_mobile.tour.skip')}</div>
      </div>}
      <FeedbackPopup isVisible={feedback} closePopup={() => setFeedback(false)} title={t('home_mobile.feedback')}></FeedbackPopup>
      <SelectTagPopup isVisible={!tourOpen && !showConnectTips && selectedTag} type={'home'} closePopup={() => setSelectedTag(false)}></SelectTagPopup>
      <EligibleModal show={eligibleModal} onCancel={() => setEligibleModal(false)}></EligibleModal>
      {/* {quickTips && <QuickTipsModal show={quickTips} onCancel={() => setQuickTips(false)}></QuickTipsModal>} */}
      {quickTips && <Modal type={'quickTips'} cancel={() => setQuickTips(false)}></Modal>}
      <SubNotAuthMobile
        isVisible={notAuthMobile}
        confirmText={t('home_mobile.commission')}
        closePopup={() => setNotAuthMobile(false)} />
    </div>
  );
};
export default HomeMobile;
